import React from 'react'
import {Refund} from 'app/features/orders/componentsv1/edit'
import {
  selectIsValidatingDiscount,
  selectRefund,
  setShippingRefundPrice,
} from 'app/features/orders/redux/order/refundSlice'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {RefundOrder} from 'app/features/orders/models/OrderRefundState'

export const RefundSummaryAction: React.FC = () => {
  const dispatch = useDispatch()
  const refund = useSelector<RootState, RefundOrder>(selectRefund)
  const isValidating = useSelector<RootState, boolean>(selectIsValidatingDiscount)

  const handleAmountChange = (amount: number | any) => {
    dispatch(setShippingRefundPrice(amount))
  }

  return (
    <Refund
      {...refund}
      title={
        <>
          Refund Summary
          {isValidating && (
            <span className='indicator-progress d-block'>
              <span className='spinner-border spinner-border spinner-border-sm align-middle ms-2 text-info'></span>
            </span>
          )}
        </>
      }
      shippingPrice={refund.shippingRefundPrice}
      totalPrice={refund.totalPrice}
      totalTax={refund.totalTax}
      onRefundAmountChange={handleAmountChange}
      maxRefundPrice={refund.maxShippingRefundFee}
      disabled={isValidating}
    />
  )
}

export default RefundSummaryAction
